<template>
  <div>
    <div class="h1 mt-4 mb-3">
      {{ $t('search:noObjectsWereFound') }}
    </div>
    <ul>
      <li>{{ $t('search:advises.spelling') }}</li>
      <li>{{ $t('search:advises.searchTerms') }}</li>
      <li>{{ $t('search:advises.travelData') }}</li>
      <li>{{ $t('search:advises.mapSection') }}</li>
      <li v-show="activeFilters.length">
        {{ $t('search:advises.filters') }}
      </li>
    </ul>
    <button
      v-show="!smallDevice && !activeFilters.length"
      class="btn btn-primary"
      type="button"
      :data-ident="`zoomOut`"
      @click="zoomOut"
    >
      {{ $t('search:expandMapSnippet') }}
    </button>
    <button
      v-show="activeFilters.length"
      class="btn btn-primary"
      type="button"
      :data-ident="`resetAll`"
      @click="resetAll"
    >
      {{ $t('search:resetFilter') }}
    </button>
    <hr>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import difference from 'lodash.difference';
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import DeviceHelper from 'mixins/DeviceHelper';

export default {
  name: 'SearchEmptyResult',
  i18nOptions: { namespaces: 'search' },
  mixins: [DeviceHelper],
  setup() {
    return {
      searchRedirect,
    };
  },
  data() {
    return {
      noResetFilter: ['objectsPerPage'],
    };
  },
  computed: {
    activeFilters() {
      const storeFilters = this.getSearchFilters();
      const resetFilter = difference(Object.keys(storeFilters), this.noResetFilter).filter((filter) => filter !== 'persons');
      return resetFilter;
    },
    smallDevice() { return ['xs', 'sm', 'md'].includes(this.dh_breakpoint); },
  },
  methods: {
    ...mapMutations({ setMapZoom: 'SET_MAP_ZOOM' }),
    ...mapGetters({ getActiveFilterCount: 'getActiveFilterCount', getSearchFilters: 'getSearchFilters' }),
    resetAll() {
      const toDelete = {};
      this.activeFilters.forEach((filter) => {
        toDelete[filter] = null;
      });
      this.searchRedirect({ router: this.$router, filters: { ...toDelete } });
    },
    zoomOut() {
      this.setMapZoom({ mapZoom: true });
    },
  },
};
</script>
